var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9512 7.91704C11.0205 7.26042 11.7337 6.08016 11.7337 4.73333C11.7337 2.67147 10.0622 1 8.00038 1C5.93851 1 4.26704 2.67147 4.26704 4.73333C4.26704 6.08017 4.98024 7.26042 6.04956 7.91705C3.96166 8.74221 2.40039 10.7398 2.40039 12.3333C2.40039 14.3952 6.03225 15 8.00039 15C9.96853 15 13.6004 14.3952 13.6004 12.3333C13.6004 10.7397 12.0391 8.7422 9.9512 7.91704Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/person-filled.093feb737e0c88a29a251c4d2600857e.svg";
export { ForwardRef as ReactComponent };